/**
 * hey-cart — klientlogik for Hey-kurvfunktionerne i kurv-draweren.
 *
 * Draweren (#cart) får sin innerHTML udskiftet af temaets handleCartPanel()
 * ved hver kurvændring. Vi observerer #cart og:
 *   1) udfører gave-tilføjelse/-fjernelse ud fra server-beregnede signaler
 *      (data-hey-gift-actions fra hey-cart-progress.liquid),
 *   2) henter anbefalinger via /recommendations/products ind i
 *      [data-hey-recs] (hey-cart-recommendations.liquid),
 *   3) dispatcher temaets eget 'ajaxCart'-event, så alle form.f8pr bindes
 *      af formOverride() — selve add-to-cart kører 100 % i temaets pipeline.
 *
 * Kurv-opdateringer efter gavehandlinger afleveres til temaets egen
 * re-render via ajaxCart.load(response) (Section Rendering API).
 */
(function () {
  'use strict';

  /* Tema-fejl-fix (rammer også live-temaet, kører selv med ?hey=off):
     what-input i scripts-async.js sætter kun data-whatin på <html> ved
     SKIFT af input-type, og typen huskes i sessionStorage — derfor
     mangler attributten på alle sider efter den første i en fane, og
     alle hover-menuer (dropdown-navigationen) er døde, indtil brugeren
     tilfældigvis taster og derefter flytter musen. Vi sætter den selv. */
  function fixWhatin(type) {
    var html = document.documentElement;
    if (html.getAttribute('data-whatin')) { return; }
    var intent = type || html.getAttribute('data-whatintent');
    if (intent && intent !== 'initial') { html.setAttribute('data-whatin', intent); }
  }
  var whatinObserver = new MutationObserver(function () {
    fixWhatin();
    if (document.documentElement.getAttribute('data-whatin')) { whatinObserver.disconnect(); }
  });
  whatinObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-whatintent'] });
  // { once: true }: attributten skal kun sættes én gang — tidligere kørte
  // dette ved HVER musebevægelse og kostede unødigt arbejde under scroll
  window.addEventListener('mousemove', function () { fixWhatin('mouse'); }, { passive: true, once: true });
  window.addEventListener('touchstart', function () { fixWhatin('touch'); }, { passive: true, once: true });
  fixWhatin();

  /* Kill-switch til fejlsøgning: ?hey=off slår AL Hey-funktionalitet fra
     (JS, CSS, paneler) for resten af browser-sessionen; ?hey=on slår til igen. */
  var heyOff = false;
  try {
    if (/[?&]hey=on\b/.test(location.search)) { sessionStorage.removeItem('heyOff'); }
    else if (/[?&]hey=off\b/.test(location.search)) { sessionStorage.setItem('heyOff', '1'); }
    heyOff = sessionStorage.getItem('heyOff') === '1';
  } catch (e) {}
  if (heyOff) {
    document.querySelectorAll('link[href*="hey-cart.css"]').forEach(function (l) { l.disabled = true; });
    document.querySelectorAll('style[data-hey]').forEach(function (s) { s.remove(); });
    ['hey-cart-recs-panel', 'hey-viewed'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) { el.remove(); }
    });
    return;
  }

  /* Tracking: pusher hey_*-events til dataLayer/gtag hvis de findes —
     ingen egne cookies, ingen eksterne kald. */
  window.heyTrack = function (name, params) {
    try {
      var payload = params || {};
      if (window.dataLayer && window.dataLayer.push) {
        var d = { event: 'hey_' + name };
        for (var k in payload) { d[k] = payload[k]; }
        window.dataLayer.push(d);
      } else if (typeof window.gtag === 'function') {
        window.gtag('event', 'hey_' + name, payload);
      }
    } catch (e) {}
  };

  /* Delegeret klik-tracking på alle hey-formularers Læg i kurv */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form.f8pr')) { return; }
    var src = f.querySelector('input[name="properties[_hey_source]"]');
    if (src) { window.heyTrack('add', { source: src.value }); }
  }, true);

  var giftBusy = false;
  var giftFailed = {};
  var recsToken = 0;

  /* ---------- gaver (fase 2) ---------- */

  function handleGiftResponse(response) {
    giftBusy = false;
    if (response && response.sections && typeof ajaxCart !== 'undefined') {
      // Bevar drawerens åben-tilstand: temaets render-pipeline lukker
      // panelet undervejs, og kun showCartPanel genåbner det. Var draweren
      // åben, skal den forblive åben efter gave-/antals-opdateringen.
      var container = document.getElementById('cart');
      var keepOpen = !!(container && container.getAttribute('aria-hidden') === 'false');
      ajaxCart.load(response, keepOpen);
    }
  }

  function processGifts(container) {
    if (giftBusy) { return; }
    var el = container.querySelector('[data-hey-gift-actions]');
    if (!el) { return; }
    var removeKeys = (el.getAttribute('data-remove') || '').split(',').filter(Boolean);
    var addIds = (el.getAttribute('data-add') || '').split(',').filter(Boolean)
      .filter(function (id) { return !giftFailed[id]; });

    if (removeKeys.length) {
      giftBusy = true;
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: removeKeys[0], quantity: 0, sections: 'side-cart' })
      })
        .then(function (r) { return r.json(); })
        .then(handleGiftResponse)
        .catch(function (e) { giftBusy = false; console.log('hey-cart gift remove error', e); });
    } else if (addIds.length) {
      giftBusy = true;
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: parseInt(addIds[0], 10), quantity: 1, properties: { _gift: 'true', _hey_source: 'gave' } }],
          sections: 'side-cart'
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) { // fx udsolgt — undgå uendelig retry
            giftFailed[addIds[0]] = true;
            giftBusy = false;
            return;
          }
          window.heyTrack('gift_added', {});
          handleGiftResponse(response);
        })
        .catch(function (e) { giftFailed[addIds[0]] = true; giftBusy = false; console.log('hey-cart gift add error', e); });
    }
  }

  /* ---------- maks 1 stk. pr. tilkøb (fase 1) ---------- */

  function fixAddonQty(container) {
    if (giftBusy) { return; }
    var el = container.querySelector('[data-hey-addon-fix]');
    if (!el) { return; }
    var keys = (el.getAttribute('data-hey-addon-fix') || '').split(',').filter(Boolean);
    if (!keys.length) { return; }
    giftBusy = true;
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: keys[0], quantity: 1, sections: 'side-cart' })
    })
      .then(function (r) { return r.json(); })
      .then(handleGiftResponse)
      .catch(function (e) { giftBusy = false; console.log('hey-cart addon qty error', e); });
  }

  /* ---------- anbefalinger (fase 3) + desktop-panel ved siden af kurven ---------- */

  function cartIsOpen(container) {
    return container.getAttribute('aria-hidden') === 'false';
  }

  // Synkroniserer KUN synlighed (kaldes også når draweren åbnes/lukkes).
  // Indholdet røres ikke her, så panelet ikke blinker under gen-hentning.
  function syncRecsPanel(container) {
    var panel = document.getElementById('hey-cart-recs-panel');
    if (!panel) { return; }
    var show = panel.getAttribute('data-has-content') === '1' && cartIsOpen(container);
    panel.hidden = false; // synlighed styres af klassen, så panelet kan glide
    panel.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show) {
      // et frame før klassen sættes, så første åbning også animerer
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { panel.classList.add('is-open'); });
      });
    } else {
      panel.classList.remove('is-open');
    }
  }

  // Udskifter panelets indhold — kaldes kun når nye data er klar, så
  // panelet bliver stående og blot skifter produkter ved kurvændringer.
  function updateRecsPanelContent(container) {
    var panel = document.getElementById('hey-cart-recs-panel');
    if (!panel) { return; }
    var box = container.querySelector('[data-hey-recs]');
    var hasContent = false;
    if (box && !box.hidden) {
      var list = box.querySelector('[data-hey-recs-list]');
      hasContent = !!(list && list.children.length);
    }
    if (hasContent) {
      panel.innerHTML = box.innerHTML;
      // klonede formularer skal bindes på ny af temaets formOverride
      panel.querySelectorAll('form.cart-initialized').forEach(function (f) {
        f.classList.remove('cart-initialized');
      });
    }
    panel.setAttribute('data-has-content', hasContent ? '1' : '0');
    syncRecsPanel(container);
    if (hasContent) { bindForms(document); }
  }

  function refreshRecs(container) {
    var box = container.querySelector('[data-hey-recs]');
    if (!box) { updateRecsPanelContent(container); return; }
    // hent først når draweren er åben — ellers bruges der båndbredde på
    // hver sidevisning uden at kunden ser anbefalingerne
    if (!cartIsOpen(container) && !box.getAttribute('data-hey-fetched')) { return; }
    box.setAttribute('data-hey-fetched', '1');
    // Hent anbefalinger for op til 4 kurv-produkter (dyreste først) og
    // flet dem — API'et giver maks 10 pr. produkt, så flere kilder giver
    // en lang, scrollbar liste. Dubletter fjernes på produkt-URL.
    var sources = (box.getAttribute('data-sources') || box.getAttribute('data-source') || '')
      .split(',').filter(Boolean).slice(0, 4);
    if (!sources.length) { box.hidden = true; updateRecsPanelContent(container); return; }
    var totalMax = parseInt(box.getAttribute('data-limit') || '12', 10);
    var intent = box.getAttribute('data-intent') || 'complementary';
    var perFetch = Math.min(10, totalMax);
    var token = ++recsToken;
    Promise.all(sources.map(function (pid) {
      var url = window.Shopify.routes.root + 'recommendations/products' +
        '?product_id=' + pid + '&limit=' + perFetch + '&intent=' + intent + '&section_id=side-cart';
      return fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (texts) {
      if (token !== recsToken) { return; }
      var target = container.querySelector('[data-hey-recs] [data-hey-recs-list]');
      if (!target) { return; }
      var seen = {};
      var merged = [];
      texts.forEach(function (text) {
        if (!text) { return; }
        var list = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-hey-recs-list]');
        if (!list) { return; }
        Array.prototype.forEach.call(list.children, function (li) {
          var link = li.querySelector('h4 a');
          var key = link ? link.getAttribute('href').split('?')[0] : merged.length + '';
          if (seen[key] || merged.length >= totalMax) { return; }
          seen[key] = true;
          merged.push(li);
        });
      });
      if (merged.length) {
        target.innerHTML = '';
        merged.forEach(function (li) { target.appendChild(li); });
        target.closest('[data-hey-recs]').hidden = false;
        bindForms(document);
      } else {
        target.closest('[data-hey-recs]').hidden = true;
      }
      updateRecsPanelContent(container);
    }).catch(function (e) { console.log('hey-cart recs error', e); });
  }

  /* ---------- form-binding via temaets eget event ---------- */

  function bindForms(root) {
    if (root.querySelector('#cart form.f8pr:not(.cart-initialized), #hey-cart-recs-panel form.f8pr:not(.cart-initialized)')) {
      window.dispatchEvent(new CustomEvent('ajaxCart'));
    }
  }

  /* ---------- tidligere set-boks (læser temaets egen tracking) ---------- */

  function formatMoney(cents) {
    if (cents % 100 === 0) { return (cents / 100) + ' kr'; }
    return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
  }

  function imageUrl(src, width) {
    if (!src) { return ''; }
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function initViewed() {
    var box = document.getElementById('hey-viewed');
    if (!box) { return; }
    if (sessionStorage.getItem('heyViewedClosed') === '1') { return; }
    var closeLink = box.querySelector('[data-hey-viewed-close]');
    if (closeLink) {
      closeLink.addEventListener('click', function (e) {
        e.preventDefault();
        box.hidden = true;
        box.setAttribute('aria-hidden', 'true');
        try { sessionStorage.setItem('heyViewedClosed', '1'); } catch (err) {}
      });
    }
    var data = [];
    try { data = JSON.parse(localStorage.getItem('recentlyViewedProduct')) || []; } catch (e) {}
    if (!data.length) { return; }
    var max = parseInt(box.getAttribute('data-max') || '3', 10);
    var currentId = (typeof general !== 'undefined' && general.viewed_product_id) ? general.viewed_product_id : null;
    // nyeste først; produktet på den aktuelle side vises ikke
    var items = data.slice().reverse().filter(function (item) {
      return item.productId !== currentId;
    }).slice(0, max);
    if (!items.length) { return; }
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 600); };
    idle(function () { loadViewed(items, box); });
  }

  function loadViewed(items, box) {
    Promise.all(items.map(function (item) {
      var path;
      try { path = new URL(item.productUrl, window.location.origin).pathname; }
      catch (e) { return Promise.resolve(null); }
      return fetch(path + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var list = box.querySelector('[data-hey-viewed-list]');
      if (!list) { return; }
      list.innerHTML = '';
      products.filter(Boolean).forEach(function (p) {
        var li = document.createElement('li');
        var compare = p.compare_at_price && p.compare_at_price > p.price
          ? '<del>' + formatMoney(p.compare_at_price) + '</del> ' : '';
        li.innerHTML = '<a href="' + p.url + '">' +
          (p.featured_image ? '<img src="' + imageUrl(p.featured_image, 160) + '" loading="lazy" alt="">' : '') +
          '<span class="title"></span>' +
          '<span class="price">' + compare + '<strong>' + formatMoney(p.price) + '</strong></span></a>';
        li.querySelector('.title').textContent = p.title;
        list.appendChild(li);
      });
      if (list.children.length) {
        box.hidden = false;
        box.setAttribute('aria-hidden', 'false');
      }
    });
  }

  /* ---------- flueben-tilvalg på produktsiden (S&D-fallback) ---------- */

  function initProductAddons() {
    var box = document.querySelector('[data-hey-pa][data-source]');
    if (!box) { return; }
    var source = box.getAttribute('data-source');
    var limit = box.getAttribute('data-max') || 5;
    // Komplementære produkter kræver opsætning i Search & Discovery — er
    // listen tom, falder vi tilbage på relaterede, så rækken aldrig står tom
    var intents = (box.getAttribute('data-intent') || 'complementary,related').split(',');
    function tryIntent(i) {
      if (i >= intents.length) { return; }
      var url = window.Shopify.routes.root + 'recommendations/products' +
        '?product_id=' + source + '&limit=' + limit +
        '&intent=' + intents[i].trim() + '&section_id=hey-addons-render';
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (text) {
          var list = text && new DOMParser().parseFromString(text, 'text/html').querySelector('[data-hey-pa-list]');
          if (list && list.children.length) {
            box.querySelector('[data-hey-pa-list]').innerHTML = list.innerHTML;
            box.hidden = false;
          } else {
            tryIntent(i + 1);
          }
        })
        .catch(function (e) { console.log('hey-pa error', e); tryIntent(i + 1); });
    }
    tryIntent(0);
  }

  /* ---------- topbar: opdatér milepæls-teaser ved kurvændring ---------- */

  var topbarToken = 0;
  var topbarFirst = true;

  function refreshTopbarMilestone() {
    var el = document.querySelector('[data-hey-topbar-ms]');
    if (!el) { return; }
    // ved sideload er teaseren allerede korrekt serverrenderet
    if (topbarFirst) { topbarFirst = false; return; }
    var token = ++topbarToken;
    fetch(window.Shopify.routes.root + '?section_id=hey-topbar')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        if (!text || token !== topbarToken) { return; }
        var fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-hey-topbar-ms]');
        if (fresh) {
          el.innerHTML = fresh.innerHTML;
          el.hidden = fresh.hidden;
        }
      })
      .catch(function () {});
  }

  /* ---------- flueben lægger direkte i kurven ---------- */

  var paBusy = false;

  function paToggle(input) {
    if (paBusy) { input.checked = !input.checked; return; }
    var id = parseInt(input.getAttribute('data-id'), 10);
    if (!id) { return; }
    paBusy = true;
    input.disabled = true;
    var done = function (response) {
      paBusy = false;
      input.disabled = false;
      if (response && response.sections && typeof ajaxCart !== 'undefined') {
        // opdater kurv og tæller UDEN at åbne draweren, så valget ikke afbrydes
        ajaxCart.load(response, false);
      }
      var row = input.closest('li');
      if (row) { row.classList.toggle('is-added', input.checked); }
    };
    var fail = function () { paBusy = false; input.disabled = false; input.checked = !input.checked; };

    if (input.checked) {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: id, quantity: 1, properties: { _hey_source: 'tilvalg' } }],
          sections: 'side-cart'
        })
      }).then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) { fail(); return; }
          window.heyTrack('add', { source: 'tilvalg' });
          done(response);
        }).catch(fail);
    } else {
      // fjern varen igen
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = null;
          cart.items.forEach(function (item) { if (item.variant_id === id) { line = item.key; } });
          if (!line) { paBusy = false; input.disabled = false; return; }
          return fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: line, quantity: 0, sections: 'side-cart' })
          }).then(function (r) { return r.json(); }).then(done);
        }).catch(fail);
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input && input.matches && input.matches('.hey-pa input[type="checkbox"][data-id]')) {
      var box = input.closest('[data-hey-pa]');
      // 'button'-tilstand håndteres af temaets eget upsell-flow ved Læg i kurv
      if (box && box.getAttribute('data-mode') === 'button') {
        input.closest('li').classList.toggle('is-checked', input.checked);
        if (window.heyVolRender) { window.heyVolRender(); }
        return;
      }
      paToggle(input);
    }
  });

  /* ---------- selvkørende nedtælling ([data-hey-cd]) ---------- */

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  var cdNodes = null;

  function tickCountdowns(refresh) {
    if (refresh || !cdNodes) { cdNodes = document.querySelectorAll('[data-hey-cd]'); }
    var nodes = cdNodes;
    if (!nodes.length || document.hidden) { return; }
    var now = Math.floor(Date.now() / 1000);
    nodes.forEach(function (el) {
      var target = parseInt(el.getAttribute('data-target'), 10);
      if (!target) { return; }
      var rem = target - now;
      // rabatkode-boksen (evergreen): udløbet → ny periode for besøgende
      if (rem <= 0) {
        var codeBox = el.closest('[data-hey-code], [data-hey-reserve]');
        if (codeBox) {
          var secs = parseInt(codeBox.getAttribute('data-secs'), 10) || 7200;
          target = now + secs; rem = secs;
          el.setAttribute('data-target', String(target));
          try { localStorage.setItem(codeBox.getAttribute('data-key'), String(target)); } catch (err) {}
        }
      }
      var txt;
      if (rem <= 0) {
        txt = '00:00:00';
      } else {
        var d = Math.floor(rem / 86400);
        var h = Math.floor((rem % 86400) / 3600);
        var m = Math.floor((rem % 3600) / 60);
        var sec = rem % 60;
        if (el.getAttribute('data-hey-cd-format') === 'ms' && d === 0 && h === 0) {
          txt = pad(m) + ':' + pad(sec);
        } else {
          txt = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
        }
      }
      if (el.getAttribute('data-hey-cd-txt') === txt) { return; }
      el.setAttribute('data-hey-cd-txt', txt);
      // hvert ciffer i sin egen faste kasse (.hey-cd__d), så teksten ved
      // siden af ikke rykker sig, når et smalt 1-tal bliver til et 0
      el.innerHTML = txt.replace(/\d/g, '<span class="hey-cd__d">$&</span>');
    });
  }

  // rabatkode: klik kopierer koden
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hey-code-copy]');
    if (!b) { return; }
    var code = b.textContent.trim(), label = b.getAttribute('data-copied') || 'Kopieret!';
    var done = function () {
      b.classList.add('is-copied');
      b.setAttribute('data-code', code);
      b.textContent = label;
      setTimeout(function () { b.textContent = code; b.classList.remove('is-copied'); }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else { done(); }
  });

  function startCountdowns() {
    tickCountdowns();
    // 1 s-tik kun mens der findes ure på siden; ellers tjekkes hvert 5. s
    (function loop() {
      var has = cdNodes && cdNodes.length;
      setTimeout(function () { tickCountdowns(!has); loop(); }, has ? 1000 : 5000);
    })();
  }

  /* ---------- søgeresultater: 6 produkter i stedet for temaets 4 ----------
     Temaets getSearchResults er en global var — vi pakker den ind og
     retter limit i URL'en, når fetch kaldes fra den. */
  (function () {
    if (typeof window.fetch !== 'function') { return; }
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        if (typeof input === 'string' && input.indexOf('section_id=livesearch') !== -1) {
          input = input.replace('resources[limit]=4', 'resources[limit]=6');
        }
      } catch (e) {}
      return origFetch.call(this, input, init);
    };
  })();

  /* ---------- mega-menu: skarpe billeder + "Se alle"-link ----------
     Temaet henter underkategori-ikonerne i 60px; kortene er ~190px, så
     URL'ens width/height skrues op. Toggle-linket ("Alle kategorier")
     bruges som "Se alle"-knap i bunden af panelet. */
  function initMegaMenu() {
    if (window.innerWidth < 1001) { return; }
    // temaet fjerner kun .hover når et ANDET .sub-punkt hoveres — så panelet
    // blev hængende, når musen gik til fx "Mest populær". Luk ved hover på
    // ethvert andet punkt, og når musen forlader hele menuen.
    var nav = document.getElementById('nav');
    if (nav && !nav.hasAttribute('data-hey-mm')) {
      nav.setAttribute('data-hey-mm', '1');
      var closeAll = function (except) {
        nav.querySelectorAll('#nav > ul > li.sub.hover').forEach(function (li) {
          if (li !== except) { li.classList.remove('hover'); li.setAttribute('aria-expanded', 'false'); }
        });
      };
      nav.querySelectorAll('#nav > ul > li').forEach(function (li) {
        li.addEventListener('mouseenter', function () { closeAll(li); });
      });
      nav.addEventListener('mouseleave', function () { closeAll(null); });
    }
    document.querySelectorAll('#nav > ul > li.sub').forEach(function (li) {
      var wide = li.querySelector(':scope > ul.wide'); if (!wide) { return; }
      wide.querySelectorAll('.img.category img').forEach(function (img) {
        var src = img.getAttribute('src') || '';
        if (src.indexOf('width=60') !== -1) {
          var big = src.replace(/width=60/, 'width=400').replace(/height=60/, 'height=400');
          img.setAttribute('src', big); img.removeAttribute('srcset');
        }
      });
      if (!wide.querySelector('.hey-mm__all')) {
        var main = li.querySelector(':scope > a[href]');
        if (main && main.getAttribute('href') !== './') {
          var br = document.createElement('span'); br.className = 'hey-mm__break'; wide.appendChild(br);
          var a = document.createElement('a');
          a.className = 'hey-mm__all'; a.href = main.getAttribute('href');
          a.textContent = 'Se alle i ' + main.textContent.trim().toLowerCase() + ' →';
          wide.appendChild(a);
        }
      }
    });
  }

  /* ---------- init ---------- */


  /* ---------- kurv: + Værdikupon · + Kommentar (Watery) ----------
     Kuponen lægges på checkout-URL'en (?discount=KODE) — Shopifys
     standard, så koden valideres i checkout. Kommentaren gemmes som
     cart note via /cart/update.js. Begge bindes ved hver drawer-render. */
  function initCartExtras(container) {
    var box = container.querySelector('.hey-cart-extras');
    if (!box || box.getAttribute('data-hey-bound')) { return; }
    box.setAttribute('data-hey-bound', '1');
    box.querySelectorAll('[data-hey-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-hey-toggle');
        box.querySelectorAll('[data-hey-panel]').forEach(function (p) {
          p.hidden = !(p.getAttribute('data-hey-panel') === key && p.hidden);
        });
      });
    });
    var coupon = box.querySelector('[data-hey-coupon]');
    var applyBtn = box.querySelector('[data-hey-coupon-apply]');
    function applyCoupon() {
      var code = (coupon.value || '').trim();
      if (!code || !applyBtn) { return; }
      // Shopifys /discount/KODE lægger koden på kurven (cookie) — bagefter
      // hentes kurven igen, så rabatlinje og total opdateres i draweren.
      applyBtn.disabled = true; applyBtn.textContent = '\u2026';
      box.querySelectorAll('.hey-cart-extras__msg').forEach(function (m) { m.remove(); });
      fetch(window.Shopify.routes.root + 'discount/' + encodeURIComponent(code) + '?redirect=/cart', { credentials: 'same-origin' })
        .then(function () { return fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code.toUpperCase(); });
          var ok = codes.indexOf(code.toUpperCase()) !== -1;
          var msg = document.createElement('p');
          msg.className = 'hey-cart-extras__msg' + (ok ? ' is-ok' : ' is-error');
          msg.textContent = ok ? (box.getAttribute('data-coupon-ok') || 'Rabatkoden er tilføjet') : (box.getAttribute('data-coupon-err') || 'Koden er ugyldig eller gælder ikke for din kurv');
          box.querySelector('[data-hey-panel="coupon"]').appendChild(msg);
          applyBtn.disabled = false; applyBtn.textContent = ok ? '\u2713' : (box.getAttribute('data-coupon-btn') || 'Indløs');
          if (ok) {
            try { sessionStorage.setItem('heyCoupon', code); } catch (e) {}
            if (typeof ajaxCart !== 'undefined' && ajaxCart.load) { ajaxCart.load(false, false, false, true); }
          }
        })
        .catch(function () { applyBtn.disabled = false; applyBtn.textContent = box.getAttribute('data-coupon-btn') || 'Indløs'; });
    }
    if (applyBtn) { applyBtn.addEventListener('click', applyCoupon); }
    if (coupon) {
      coupon.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyCoupon(); } });
      try { var saved = sessionStorage.getItem('heyCoupon'); if (saved) { coupon.value = saved; } } catch (e) {}
    }
    var note = box.querySelector('[data-hey-note]');
    if (note) {
      var t = null;
      note.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: note.value })
          }).catch(function () {});
        }, 600);
      });
    }
  }

  /* reservations-nedtælling: måltidspunkt pr. besøgende (localStorage) */
  function initReserve(container) {
    if (container.querySelector('[data-hey-reserve-clear]')) {
      try { localStorage.removeItem('hey_cart_reserve'); } catch (e) {}
      return;
    }
    var box = container.querySelector('[data-hey-reserve]');
    if (!box) { return; }
    var key = box.getAttribute('data-key') || 'hey_cart_reserve';
    var secs = parseInt(box.getAttribute('data-secs'), 10) || 600;
    var now = Math.floor(Date.now() / 1000), target = 0;
    try { target = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) {}
    if (!target || target <= now) {
      target = now + secs;
      try { localStorage.setItem(key, String(target)); } catch (e) {}
    }
    var el = box.querySelector('[data-hey-cd]');
    if (el) { el.setAttribute('data-target', String(target)); el.removeAttribute('data-hey-cd-txt'); }
  }

  function onRender(container) {
    initReserve(container);
    initCartExtras(container);
    processGifts(container);
    fixAddonQty(container);
    refreshRecs(container);
    refreshTopbarMilestone();
    // vores eget ur skal også tikke i den gen-renderede drawer
    tickCountdowns(true);
    bindForms(document);
  }

  /* Kurv-draweren hentes normalt FØRST ved klik (ajaxCart.load), hvilket
     giver 1-2 sekunders forsinkelse. Vi forudhenter indholdet i browserens
     tomgang, så panelet åbner øjeblikkeligt — temaets egen mekanik, bare
     kaldt tidligere og uden at åbne panelet. */
  function prefetchCart(container) {
    if (typeof ajaxCart === 'undefined' || !ajaxCart.load) { return; }
    if (container.children.length >= 3) { return; }
    try { ajaxCart.load(false, false); } catch (e) {}
  }

  function start() {
    var container = document.getElementById('cart');
    if (!container) { return; }
    // Forudhent kurven ved FØRSTE tegn på interesse (hover/touch på
    // kurv-ikonet) — ellers først efter 5 sek. Tidligere skete det på
    // hver sidevisning, hvilket gen-initialiserede temaets JS-moduler og
    // gjorde siden mærkbart tung.
    var prefetched = false;
    var doPrefetch = function () {
      if (prefetched) { return; }
      prefetched = true;
      prefetchCart(container);
    };
    document.querySelectorAll('a[data-panel="cart"], li.cart > a').forEach(function (el) {
      el.addEventListener('pointerenter', doPrefetch, { once: true, passive: true });
      el.addEventListener('touchstart', doPrefetch, { once: true, passive: true });
    });
    setTimeout(doPrefetch, 5000);
    // panelet renderes uden for #root i theme.liquid — flyt det ind, så
    // temaets #root-scopede knap-/formularstyling gælder derinde
    var panel = document.getElementById('hey-cart-recs-panel');
    var root = document.getElementById('root');
    if (panel && root && panel.parentElement !== root) {
      root.appendChild(panel);
    }
    // Slet skal føles øjeblikkeligt: temaet venter på /cart/change +
    // gen-rendering (1-2 s) før linjen skifter udseende. Vi sætter
    // temaets egen "removing"-tilstand (Produkt fjernet · Fortryd) med det
    // samme i capture-fasen og tæller headeren ned — temaets handler kører
    // derefter som normalt og flytter linjen med over i den nye rendering.
    container.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a.remove-from-cart-link');
      if (!link) { return; }
      e.preventDefault(); // temaets handler sender selv /cart/change
      var li = link.closest('li');
      if (!li || li.classList.contains('removing')) { return; }
      li.classList.add('removing', 'hey-optimistic');
      li.style.display = 'none';
      var count = container.querySelector('.hey-cart-count');
      var input = li.querySelector('.input-amount input');
      var qty = input ? parseInt(input.value, 10) || 1 : 1;
      if (count) {
        var n = parseInt(count.textContent.replace(/\D/g, ''), 10) || 0;
        count.textContent = '(' + Math.max(0, n - qty) + ')';
      }
    }, true);
    new MutationObserver(function () {
      onRender(container);
    }).observe(container, { childList: true });
    // synkronisér anbefalingspanelet når draweren åbnes/lukkes
    new MutationObserver(function () {
      if (cartIsOpen(container)) { refreshRecs(container); }
      syncRecsPanel(container);
    }).observe(container, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
    onRender(container);
  }



  /* ---------- udsolgte varer bagerst i kollektionen ----------
     Shopify sorterer ikke efter lagerstatus, så udsolgte varer lander
     midt i gitteret. Kortene bærer allerede temaets klasse .unavailable,
     så de kan flyttes bagerst i den viste side. BEMÆRK: det virker pr.
     side — hvilke produkter der havner på side 1, bestemmer Shopify. */
  var sortBusy = false;
  function sortSoldOutLast(root) {
    if (sortBusy) { return; }
    var grids = (root || document).querySelectorAll('ul.l4cl:not(.upsell)');
    sortBusy = true;
    grids.forEach(function (grid) {
      var cards = Array.prototype.slice.call(grid.children);
      var sold = cards.filter(function (li) {
        return li.classList && li.classList.contains('unavailable');
      });
      if (!sold.length || sold.length === cards.length) { return; }
      // står de allerede sidst, gøres intet (undgår unødige reflows)
      var tail = cards.slice(cards.length - sold.length);
      if (tail.every(function (li) { return li.classList.contains('unavailable'); })) { return; }
      var frag = document.createDocumentFragment();
      sold.forEach(function (li) { frag.appendChild(li); });
      grid.appendChild(frag);
    });
    sortBusy = false;
  }

  function watchGrids() {
    if (!document.querySelector('ul.l4cl:not(.upsell)')) { return; }
    sortSoldOutLast(document);
    // filtre og "vis flere" gengiver gitteret — sortér igen bagefter
    var pending = null;
    new MutationObserver(function () {
      if (sortBusy) { return; }
      clearTimeout(pending);
      pending = setTimeout(function () { sortSoldOutLast(document); }, 60);
    }).observe((document.querySelector('ul.l4cl:not(.upsell)') || document.body).parentElement, { childList: true, subtree: true });
  }


  /* ---------- Køb flere, spar mere (produktside) ----------
     Kortene og +/- sætter ANTAL i temaets egen købsformular, så
     Læg i kurv og checkout er temaets — ingen parallel kurvkode. */
  function initVolume() {
    var box = document.querySelector('[data-hey-vol]');
    if (!box) { return; }
    // VIGTIGT: temaet ERSTATTER antalsfeltet efter indlæsning (det klones
    // til sticky-baren, og originalen byttes ud). En reference gemt ved
    // start peger derfor på et dødt element. Feltet slås op hver gang.
    function qty() {
      var el = document.getElementById('quantity');
      if (!el || el.type === 'hidden') {
        el = document.querySelector('form[id^="main-product-form"] input[type="number"][name="quantity"]');
      }
      return el;
    }
    if (!qty()) { return; }
    var tiers = box.querySelectorAll('[data-hey-vol-qty]');
    var article = document.getElementById('main-product') || document;
    var base = parseInt(box.getAttribute('data-base'), 10) || 0;   // øre
    var priceOriginal = null, btnLabel = null;

    function priceEl() { return article.querySelector('.f8pr-price'); }
    function btnEl() { var q = qty(); var f = q && q.closest('form'); return f ? f.querySelector('button[type="submit"]') : null; }
    // hele kroner — som resten af shoppen (289 kr, ikke 289,00 kr)
    function money(cents) { return Math.round(cents / 100) + ' kr'; }
    function maxQty() { var q = qty(); return q ? (parseInt(q.getAttribute('max'), 10) || 0) : 0; }
    function current() { var q = qty(); return Math.max(1, parseInt(q && q.value, 10) || 1); }
    function pctFor(n) {
      var best = 0;
      tiers.forEach(function (t) {
        var tq = parseInt(t.getAttribute('data-hey-vol-qty'), 10), tp = parseInt(t.getAttribute('data-hey-vol-pct'), 10) || 0;
        if (!t.disabled && n >= tq && tp > best) { best = tp; }
      });
      return best;
    }
    // Watery-mønster: pris og knap følger antal + rabat
    function render(n) {
      var pct = pctFor(n), p = priceEl(), b = btnEl();
      tiers.forEach(function (t) {
        t.classList.toggle('is-active', !t.disabled && parseInt(t.getAttribute('data-hey-vol-qty'), 10) === n);
      });
      if (p && base) {
        if (priceOriginal === null) { priceOriginal = p.innerHTML; }
        if (pct > 0) {
          var each = Math.round(base * (100 - pct) / 100 / 100) * 100;
          p.innerHTML = '<span class="hey-vol__new">' + money(each) + '</span> ' +
                        '<span class="old-price">' + money(base) + '</span>' +
                        '<span class="hey-vol__pricetag">' + pct + '% rabat</span>';
          p.classList.add('hey-vol-discounted');
        } else {
          p.innerHTML = priceOriginal;
          p.classList.remove('hey-vol-discounted');
        }
      }
      if (b && base) {
        if (btnLabel === null) { btnLabel = b.textContent.trim(); }
        var total = Math.round(base * n * (100 - pct) / 100 / 100) * 100;
        // afkrydsede tilvalg (knap-tilstand) lægges oven i som hos Watery
        var extra = 0;
        document.querySelectorAll('[data-hey-pa][data-mode="button"] input[type="checkbox"]:checked').forEach(function (c) {
          extra += parseInt(c.getAttribute('data-price'), 10) || 0;
        });
        b.textContent = (n > 1 || extra > 0) ? btnLabel + ' \u00b7 ' + money(total + extra) : btnLabel;
      }
    }
    window.heyVolRender = function () { render(current()); };
    function apply(n) {
      var q = qty(); if (!q) { return; }
      n = Math.max(1, n);
      var mx = maxQty(); if (mx > 0) { n = Math.min(mx, n); }
      q.value = n;
      q.dispatchEvent(new Event('input', { bubbles: true }));
      q.dispatchEvent(new Event('change', { bubbles: true }));
      // sticky-barens kopi følger med
      var st = document.getElementById('product_qty_sticky'); if (st) { st.value = n; }
      render(n);
    }
    var mx0 = maxQty();
    tiers.forEach(function (t) {
      var n = parseInt(t.getAttribute('data-hey-vol-qty'), 10);
      if (mx0 > 0 && n > mx0) { t.disabled = true; }
      t.addEventListener('click', function (e) { e.preventDefault(); if (!t.disabled) { apply(n); } });
    });
    // temaets +/- og manuel indtastning: lyt på document (feltet udskiftes)
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') { render(current()); } });
    document.addEventListener('input',  function (e) { if (e.target && e.target.name === 'quantity') { render(current()); } });
    // temaets +/- (.incr/.decr) ændrer værdien uden change-event — lyt på klik
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.input-amount .incr, .input-amount .decr')) { setTimeout(function () { render(current()); }, 0); }
    }, { passive: true });
    render(current());
  }

  /* ---------- leveringslogoer ned i footerens bundlinje ----------
     Temaets footer er én sektion, så rækken kan ikke renderes inde i
     den fra Liquid. Den flyttes derfor ind ved siden af betalings-
     ikonerne, og afsløres først dér — ellers ville den nå at blinke
     forbi som en selvstændig stribe over footeren. */
  /* badges (rabat + købt i dag) ind på produktbilledet — galleriet er
     temaets, så de renderes i købskolonnen og flyttes herind */
  function moveBadges() {
    var b = document.querySelector('[data-hey-badges]');
    var box = document.querySelector('#main-product .l4pr-container');
    var gal = box && box.querySelector('.l4pr');
    if (!b || !box || !gal) { return; }
    // NB: ikke ind i selve ul.l4pr — temaets swiper gør alle børn til slides
    if (!b.classList.contains('is-moved')) {
      box.appendChild(b);
      b.classList.add('is-moved');
    }
    // placeres over det store billede: forbi thumbnail-kolonnen (ul'ens padding-left)
    var place = function () {
      // offsetLeft er relativt til containeren (sticky = positioneret)
      var pad = parseFloat(getComputedStyle(gal).paddingLeft) || 0;
      var left = gal.offsetLeft + pad;
      b.style.left = Math.round(left + 12) + 'px';
      b.style.top = Math.round(gal.offsetTop + 12) + 'px';
      b.hidden = false;
    };
    place();
    window.addEventListener('resize', place, { passive: true });
    window.addEventListener('load', place);
    [400, 1500, 3000].forEach(function (t) { setTimeout(place, t); }); // efter swiper-init
  }

  function moveDeliveryRow() {
    var row = document.querySelector('[data-hey-del-move]');
    if (!row || row.classList.contains('is-moved')) { return; }
    var bar = document.querySelector('.shopify-section-footer > .base-font');
    if (!bar) { return; }
    var payments = bar.querySelector('ul.l4pm');
    if (payments) { bar.insertBefore(row, payments); } else { bar.appendChild(row); }
    row.classList.add('is-moved');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start();
      startCountdowns();
      moveDeliveryRow();
      moveBadges();
      initMegaMenu();
      if (window.heySortSoldOut) { watchGrids(); }
      var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 700); };
      idle(function () { initViewed(); initProductAddons(); });
      initVolume();
    });
  } else {
    start();
    startCountdowns();
    moveDeliveryRow();
    moveBadges();
    initMegaMenu();
    if (window.heySortSoldOut) { watchGrids(); }
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 700); };
    idle(function () { initViewed(); initProductAddons(); });
    initVolume();
  }
})();
